import constants from "constants";
import { CLEAR_NOTIFICATIONS, SET_NOTIFICATIONS } from "../constants/actions";

const {
  CREATE_USER_SAGA,
  LOAD_CURRENT_USER_SAGA,
  UPDATE_URL_USER_SAGA,
  UPDATE_USER,
  UPDATE_USER_SAGA,
  CONFIRM_EMAIL_SAGA,
  ADD_ADMIN_USERS,
  LOAD_ADMIN_USERS_SAGA,
  ADMIN_CREATE_USER_SAGA,
  ADMIN_CREATE_USER_SPONSOR_SAGA,
  ADMIN_DELETE_USERS_SAGA,
  LOAD_EDIT_USER_SAGA,
  SET_EDIT_USER,
  ADMIN_UPDATE_USER_SAGA,
  USER_FILTER_SAGA,
  USER_SPONSOR_FILTER_SAGA,
  LOAD_ADMIN_DASHBOARD_USERS_SAGA,
  ADD_ADMIN_DASHBOARD_USERS,
  SET_PROFILE_CONFIRMATION,
  ADMIN_POST_ASSIGNED_USERS_SAGA,
  ADD_ASSIGNED_USERS,
  APPROVE_DISCIPLINE_FILTER_SAGA,
  ADD_CONFIRMATION_USERS,
  LOAD_SUBSCRIBED_USERS_SAGA,
  LOAD_NOVONORDISK_SUBSCRIBED_USERS_SAGA,
  ADD_NOVONORDISK_USERS,
  // CHECKBOX_NOVONORDISK_USER_SAGA,
  UPDATE_NOVONORDISK_USER_SAGA,
  UPDATE_USER_NOVONORDISK,
  // GET_SPONSORS_REPRESENTATIVE,
  // SET_SPONSORS_REPRESENTATIVE,
  // GET_SPONSORS_REPRESENTATIVE_REQUESTS,
  // SET_SPONSORS_REPRESENTATIVE_REQUESTS,
  // CLEAR_SPONSORS_REPRESENTATIVE_REQUESTS,
  ADMIN_GET_CERTIFICATES_USERS,
  ADMIN_SET_CERTIFICATES_USERS,
  ADMIN_CREATE_CERTIFICATES_USERS,
  ADMIN_CLEAR_CERTIFICATES_USERS,
  LOAD_NOTIFICATIONS,
  SET_NOTIFICATIONS_INFINITE,
  GET_NOTIFICATIONS,
  REGISTER_REQUEST_TO_ADMIN,
  LOAD_NOTIFICATIONS_COUNT,
  SET_NOTIFICATIONS_COUNT,
  MARK_NOTIFICATIONS,
} = constants;

export const registerRequestToAdmin = (payload) => ({
  type: REGISTER_REQUEST_TO_ADMIN,
  payload,
});

export const createUser = (user, redirect) => ({
  type: CREATE_USER_SAGA,
  user,
  redirect,
});

export const updateUserSaga = (user) => ({
  type: UPDATE_USER_SAGA,
  user,
});

export const updateNovonordiskUserSaga = (subscribed) => ({
  type: UPDATE_NOVONORDISK_USER_SAGA,
  subscribed,
});

// export const CheckboxNovonordiskUserSaga = () => ({
//   type: CHECKBOX_NOVONORDISK_USER_SAGA
// })
export const loadCurrentUser = () => ({
  type: LOAD_CURRENT_USER_SAGA,
});

export const updateUrlUser = (data) => ({
  type: UPDATE_URL_USER_SAGA,
  data,
});

export const updateUser = (user, session) => ({
  type: UPDATE_USER,
  payload: { user },
  session,
});

export const updateNovonordiskUser = (user, session) => ({
  type: UPDATE_USER_NOVONORDISK,
  payload: { user },
  session,
});

export const confirmUserEmailSaga = (token) => ({
  type: CONFIRM_EMAIL_SAGA,
  token,
});

export const addAdminUsers = (
  values,
  count,
  page,
  total_pages,
  query = {}
) => ({
  type: ADD_ADMIN_USERS,
  payload: {
    values,
    count,
    page,
    total_pages,
    query,
  },
});

export const addConfirmationUsers = (
  values,
  count,
  page,
  total_pages,
  query = {}
) => ({
  type: ADD_CONFIRMATION_USERS,
  payload: {
    values,
    count,
    page,
    total_pages,
    query,
  },
});
export const loadSubscribedUsersSaga = () => ({
  type: LOAD_SUBSCRIBED_USERS_SAGA,
});

export const loadAdminUsersSaga = (page) => ({
  type: LOAD_ADMIN_USERS_SAGA,
  page,
});

export const adminCreateUserSaga = (user) => ({
  type: ADMIN_CREATE_USER_SAGA,
  user,
});
export const adminPostAssignedUsersSaga = (
  assigned_users,
  only_assigned,
  page,
  query = {},
  per_page,
  total_pages,
  count
) => ({
  type: ADMIN_POST_ASSIGNED_USERS_SAGA,
  assigned_users,
  only_assigned,
  per_page,
  count,
  page,
  total_pages,
  query,
});

export const adminCreateUserSponsorSaga = (user) => ({
  type: ADMIN_CREATE_USER_SPONSOR_SAGA,
  user,
});

export const adminUpdateUserSaga = (user) => ({
  type: ADMIN_UPDATE_USER_SAGA,
  user,
});

export const adminDeleteUserSaga = (user_ids) => ({
  type: ADMIN_DELETE_USERS_SAGA,
  user_ids,
});

export const loadEditUser = (user_id) => ({
  type: LOAD_EDIT_USER_SAGA,
  user_id,
});

export const setEditUser = (user) => ({
  type: SET_EDIT_USER,
  payload: {
    user,
  },
});
export const addAssignedUsers = (
  values,
  count,
  page,
  total_pages,
  query = {}
) => ({
  type: ADD_ASSIGNED_USERS,
  payload: {
    values,
    count,
    page,
    total_pages,
    query,
  },
});

export const adminUserFilter = (query, page = 1, per_page = 5000) => ({
  type: USER_FILTER_SAGA,
  query,
  page,
  per_page,
});

export const approveDisciplineFilter = (query, page = 1, per_page = 5000) => ({
  type: APPROVE_DISCIPLINE_FILTER_SAGA,
  query,
  page,
  per_page,
});

// export const sendDisciplinesApproveSaga = ({confirmation_users}) => ({
//   type: SEND_DISCIPLINES_APPROVE_SAGA,
//   confirmation_users
// })

// export const sendDisciplineRejectSaga = ({confirmation_users}) => ({
//   type: SEND_DISCIPLINES_REJECT_SAGA,
//   confirmation_users
// })

export const adminUserSponsorFilter = (query, page = 1) => ({
  type: USER_SPONSOR_FILTER_SAGA,
  query,
  page,
});

export const loadAdminAdminDashboardUsersSaga = (query) => ({
  type: LOAD_ADMIN_DASHBOARD_USERS_SAGA,
  query,
});

export const addAdminAdminDashboardUsers = (statistics) => ({
  type: ADD_ADMIN_DASHBOARD_USERS,
  payload: {
    statistics,
  },
});

export const loadNovonordiskUsersSaga = (query) => ({
  type: LOAD_NOVONORDISK_SUBSCRIBED_USERS_SAGA,
  query,
});

export const addNovonordiskUsers = (values) => ({
  type: ADD_NOVONORDISK_USERS,
  payload: {
    values,
  },
});

export const setProfileConfirmation = (value) => ({
  type: SET_PROFILE_CONFIRMATION,
  payload: {
    showProfileConfirmation: value,
  },
});

// export const getSponsorsRepresentatives = () => ({
//   type: GET_SPONSORS_REPRESENTATIVE,
// });

// export const setSponsorsRepresentatives = (payload) => ({
//   type: SET_SPONSORS_REPRESENTATIVE,
//   payload,
// });

// export const getSponsorsRepresentativesRequests = (payload) => ({
//   type: GET_SPONSORS_REPRESENTATIVE_REQUESTS,
//   payload,
// });

// export const setSponsorsRepresentativesRequest = (payload) => ({
//   type: SET_SPONSORS_REPRESENTATIVE_REQUESTS,
//   payload,
// });

// export const clearSponsorsRepresentativesRequest = (payload) => ({
//   type: CLEAR_SPONSORS_REPRESENTATIVE_REQUESTS,
//   payload,
// });

export const getAdminCertificatesUsers = (payload) => ({
  type: ADMIN_GET_CERTIFICATES_USERS,
  payload,
});

export const setAdminCertificatesUsers = (payload) => ({
  type: ADMIN_SET_CERTIFICATES_USERS,
  payload,
});

export const createAdminCertificatesUsers = (payload) => ({
  type: ADMIN_CREATE_CERTIFICATES_USERS,
  payload,
});

export const clearAdminCertificatesUsers = () => ({
  type: ADMIN_CLEAR_CERTIFICATES_USERS,
});

export const getNotifications = (payload) => ({
  type: GET_NOTIFICATIONS,
  payload,
});

export const loadNotifications = (payload) => ({
  type: LOAD_NOTIFICATIONS,
  payload,
});

export const loadNotificationsCount = () => ({
  type: LOAD_NOTIFICATIONS_COUNT,
});

export const setNotificationsCount = (payload) => ({
  type: SET_NOTIFICATIONS_COUNT,
  payload,
});

export const markNotifications = (payload) => ({
  type: MARK_NOTIFICATIONS,
  payload,
});

export const setNotification = (payload) => ({
  type: SET_NOTIFICATIONS,
  payload,
});

export const setNotificationsInfinite = (payload) => ({
  type: SET_NOTIFICATIONS_INFINITE,
  payload,
});

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});



// WEBPACK FOOTER //
// ./src/actions/users.js